import React from "react";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/store";
import { Grid } from "@mui/material";
import styles from "./companyTitleBar.module.css";
import packageJson from '../../../package.json'


function CompanyTitleBar() {
    const { user } = useSelector((state: IRootState) => state.userAuth);

    return (
        <Grid className={styles.UserInfoBarOuterContainer}>
            <Grid md={8}>
                <h1>ESS 管理系統</h1>
            </Grid>

            <Grid md={4} className={styles.userInfoContainer}>
                <Grid>名稱：{user?.token?.username}</Grid>
                <Grid>身份：{user?.token?.role}</Grid>
                <Grid>version:{packageJson.version}</Grid>
            </Grid>
        </Grid>
    );
}

export default CompanyTitleBar;
